<div class="full-size">
    <app-orders-grid
      #grid
      (filterChange)="onFilterChange($event)"
      (filterClickChange)="onFilterClickChange($event)"
      [datesearch]="true"
      [suppressRowTransform]="suppressRowTransform"
      [startdate]="startDate"
      [enddate]="endDate"
    ></app-orders-grid>
</div>
